import { render, staticRenderFns } from "./PolizaPaymentData.vue?vue&type=template&id=e868bdfc"
import script from "./PolizaPaymentData.vue?vue&type=script&lang=js"
export * from "./PolizaPaymentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports